import React, { useState, useEffect } from 'react';

import moment from 'moment';

import { urls } from '../config.js'

import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import VideoNavBar from '../components/VideoNavBar';

import { general } from '../config.js';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

import PersonIcon from '@mui/icons-material/Person';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { padding } from '@mui/system';
import NotFound from '../components/NotFound.js';

const persIcon = <PersonIcon fontSize="" />



function Video() {

    const { id } = useParams();

    const [isLoading, setLoading] = useState(true)
    const [videoDetails, setVideoDetails] = useState([])
    const [videos, setVideos] = useState([])
    const [additionals, setAdditionals] = useState([])
    const [notFound, setNotFound] = useState(false)

    const navigate = useNavigate()




    const fetchData = async () => {
        let string = `${urls.clip}${id}`
        const data = await fetch(string);
        // convert the data to json
        const json = await data.json();

        // set state with the result
        if (json.error !== undefined) {
            setNotFound(true)

        }
        else {
            setVideos(json.related_clips)
            setVideoDetails(json.clip_info)
            document.title = `Showing clip "${json.clip_info.title}"`

            setAdditionals(json.additionals)
            setLoading(false)
        }
    };


    useEffect(() => {
        // call the function
        fetchData();
        // eslint-disable-next-line
    }, [id]);

    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const openLink = url => {
        navigate(url);
        window.scrollTo(0, 0)
    };


    return (
        <Container maxWidth="lg" id="standardContainer">
            {notFound ?
                <NotFound />


                :
                <Grid container spacing={2}>
                    <Grid md={9} xs={100}>
                        <item>
                            <Box>
                                {isLoading ?
                                    <Skeleton
                                        variant="rectangular"
                                        height="430px"
                                    />
                                    :
                                    <iframe
                                        src={`https://clips.twitch.tv/embed?clip=${id}&parent=${general.siteName}`}
                                        class='twitchPlayer' frameborder='0' scrolling='no' autoPlay='true' preload='metadata' allowfullscreen='true'>
                                    </iframe>
                                }
                            </Box>
                        </item>
                        <item>
                            
                                {isLoading ?
                    
                                <Typography variant="h2"> 
                                    <Skeleton /> 
                                    </Typography> 
                                    :
                                    <h3 id="videoTitle video">{videoDetails.title}</h3>
                                }
                            

                            <Grid container spacing={2}>

                                <Grid xs={12} md={9} paddingLeft={0}>
                                    <item>


                                        {isLoading ?
                                            <>
                                                <Skeleton
                                                    variant="rectangular"
                                                    height="260px" />
                                            </>

                                            :



                                            <Box id="shadowContainer">
                                                <b>Broadcasted by</b>
                                                <div id="videoPage detail text">
                                                    <Stack direction="row" spacing={1}
                                                        alignItems="center">
                                                        <item> <Avatar alt={videoDetails.broadcaster_name} src={additionals.user_profile_img} /></item>
                                                        <item>{videoDetails.broadcaster_name}</item>
                                                    </Stack></div>
                                                <b>on</b>
                                                <div id="videoPage detail text"> {moment(videoDetails.created_at).format('MMMM Do YYYY, h:mm:ss a')}</div>
                                                <b>Clip created by</b>
                                                <div id="videoPage detail text"> {videoDetails.creator_name}</div>
                                                <b>Category</b>
                                                <div id="videoPage detail text"> {additionals.category_name}</div>
                                            </Box>
                                        }

                                    </item>
                                </Grid>

                                <Grid xs={12} md={3}>
                                    {isLoading ?
                                        <Skeleton
                                            variant="rectangular"
                                            height="260px" /> :


                                        <item><img src={additionals.category_img} id="videoPage categoryImage" /></item>
                                    }
                                </Grid>
                            </Grid>


                        </item>
                    </Grid>
                    <Grid md={3} xs={100}>

                        {isLoading ?
                            <>
                                <Skeleton animation="wave" />
                                {Array.from(Array(3).keys()).map((person, i) => (

                                    <>
                                        <Grid>
                                            <item>

                                                <Skeleton variant="rectangular" height={140} />
                                                <Box sx={{ pt: 0.5 }}>
                                                    <Skeleton />
                                                    <Skeleton width="60%" />
                                                </Box>
                                            </item>
                                        </Grid>

                                    </>

                                ))}
                            </> :
                            <>
                                <h5>Related Clips</h5>

                                <Grid id="videoPage relatedVideos">
                                    {videos.map((video, index) => {

                                        let tagString = String(`
              ${video.broadcaster_name}
              `)

                                        return (
                                            <Grid key={index}>
                                                <item>
                                                    <Card sx={{ maxWidth: 500 }} onClick={() => openLink(`/video/${video.id}`)}>
                                                        <CardActionArea>
                                                            <CardMedia
                                                                component="img"
                                                                image={video.thumbnail_url}
                                                            />
                                                            <CardContent>
                                                                <Typography gutterBottom variant="h5" component="div" id="videoTitle" style={{ fontSize: 17 }}>
                                                                    {video.title}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {persIcon}
                                                                    {tagString}
                                                                    <br />
                                                                    <AccessTimeFilledIcon fontSize="" />  {" "}
                                                                    {moment(video.created_at).fromNow()}
                                                                </Typography>
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </Card>
                                                </item>
                                            </Grid>
                                        )
                                    })}
                                </Grid>



                            </>
                        }

                    </Grid>

                </Grid>
            }
        </Container >
    );
};



export default Video